let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ho4wM")).then(() => parcelRequire('lzIWk'));